export type ContactsImportMessages = {
  importContactsTitle: string;
  importContactsPlaceholder: string;
  downloadImportContactsSampleFile: string;
  importContactsButton: string;
  unsupportedFileFormat: string;
  importContactsSuccess: string;
  importContactsError: string;
};

export const CONTACTS_IMPORT_MESSAGES: ContactsImportMessages = {
  importContactsTitle: "Planilha de Contatos",
  importContactsPlaceholder: "Importar Contatos",
  downloadImportContactsSampleFile: "Baixar Planilha Modelo",
  importContactsButton: "Importar Contatos",
  unsupportedFileFormat:
    "Formato de arquivo não suportado. Por favor, envie um arquivo xls ou xlsx.",
  importContactsSuccess:
    "Recebemos seu arquivo de contatos! Você será notificado assim que o processo for finalizado.",
  importContactsError: "Erro ao importar contatos.",
};
